import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'subscription.upgrade.form.header',
    defaultMessage: 'Interested in learning more about Intersect?',
  },
  contactInformation: {
    id: 'subscription.upgrade.form.contactInformation',
    defaultMessage: 'Intersect has designed a variety of options to support the diverse needs of our partners. ' +
      'Please verify your contact details and an Intersect representative will contact you promptly about the ' +
      'solutions that will best meet your needs.',
  },
  upgradeNotice: {
    id: 'subscription.upgrade.form.notice',
    defaultMessage: 'Note: Upgrades are available for U.S. and Canadian based institutions only.',
  },
  requestInformation: {
    id: 'subscription.upgrade.form.requestInformation',
    defaultMessage: 'Request Information',
  },
  closingCount: {
    id: 'subscription.upgrade.form.closing',
    defaultMessage: 'Closing in {count, number} secs..',
  },
  thanksTitle: {
    id: 'subscription.upgrade.form.thanksTitle',
    defaultMessage: 'Thanks!',
  },
  thanksMessage: {
    id: 'subscription.upgrade.form.thanksMessage',
    defaultMessage: 'We\'ll be reaching out to you soon.',
  },
  successAlt: {
    id: 'subscription.upgrade.form.successAlt',
    defaultMessage: 'We will be in touch shortly',
  },
  enterValue: {
    id: 'subscription.upgrade.form.error.missingValue',
    defaultMessage: 'Please enter a value',
  },
  firstName: {
    id: 'subscription.upgrade.form.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'subscription.upgrade.form.lastName',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'subscription.upgrade.form.emailAddress',
    defaultMessage: 'Email',
  },
  invalidEmail: {
    id: 'subscription.upgrade.form.error.emailInvalid',
    defaultMessage: 'Invalid email address',
  },
  phone: {
    id: 'subscription.upgrade.form.phone',
    defaultMessage: 'Phone',
  },
  invalidPhone: {
    id: 'subscription.upgrade.form.error.phoneInvalid',
    defaultMessage: 'Invalid phone number',
  },
  invalidNotes: {
    id: 'subscription.upgrade.form.error.messageInvalid',
    defaultMessage: 'Limited to 500 characters',
  },
  company: {
    id: 'subscription.upgrade.form.company',
    defaultMessage: 'Institution',
  },
  jobLevel: {
    id: 'subscription.upgrade.form.job.level',
    defaultMessage: 'Job Level',
  },
  jobTopic: {
    id: 'subscription.upgrade.form.job.topic',
    defaultMessage: 'Are you interested in upgrading to a paid subscription or support for an existing subscription?',
  },
  notes: {
    id: 'subscription.upgrade.form.message',
    defaultMessage: 'Please provide more information to help us better route your request.',
  },
  hobsonsCommunication: {
    id: 'subscription.upgrade.form.optIn',
    defaultMessage: 'Receive Intersect communications related to product news, promotions, event updates, and company announcements.',
  },
  formErrors: {
    id: 'subscription.upgrade.form.errors',
    defaultMessage: 'There are form errors',
  },
});

export default messages;
